export default __webpack_public_path__ + "ee528db4394a4606036fc743e570215c.png";